/** Override historical voice quota labels in the web client without changing shared resources. */
export function actionAllowanceResources<T extends Record<string,unknown>>(source:T):T {
    const copy=structuredClone(source);
    for(const [locale,resource] of Object.entries(copy)) {
        if(locale!=='he'&&locale!=='en')continue;
        const labels=locale==='he'?{limit:'פעולות בחודש למשתמש',usage:'פעולות החודש',exhausted:'מכסת הפעולות האישית לחודש הזה נוצלה'}:{limit:'Actions per user per month',usage:'Actions this month',exhausted:'You have used this month’s personal action allowance'};
        const walk=(value:unknown,path='')=>{
            if(!value||typeof value!=='object')return;
            for(const [key,item] of Object.entries(value)) {
                const target=value as Record<string,unknown>,next=path?`${path}.${key}`:key;
                if(key==='voiceActionsPerMonth')target[key]=labels.limit;
                else if(key==='voiceActionsThisMonth')target[key]=labels.usage;
                else if(next==='translation.errors.voice.quotaReached')target[key]=labels.exhausted;
                else walk(item,next);
            }
        };
        walk(resource);
    }
    return copy;
}
